var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.873228 11.5C0.408216 11.5 0.03125 11.123 0.03125 10.658V1.34198C0.03125 0.876966 0.408216 0.5 0.873228 0.5C1.33824 0.5 1.71521 0.876966 1.71521 1.34198V5.28027H7.27935V1.3447C7.27935 0.878186 7.65753 0.5 8.12405 0.5C8.59056 0.5 8.96875 0.878186 8.96875 1.3447V10.6553C8.96875 11.1218 8.59056 11.5 8.12405 11.5C7.65753 11.5 7.27935 11.1218 7.27935 10.6553V6.70361H1.71521V10.658C1.71521 11.123 1.33824 11.5 0.873228 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorHeading);
export default __webpack_public_path__ + "static/media/editor-heading.be7e1e0d817cee8c263008e6891d298b.svg";
export { ForwardRef as ReactComponent };